export default __webpack_public_path__ + "static/media/ride.6055c9b6.jpg";